import { isVisible } from "@testing-library/user-event/dist/utils";
import React from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";

function GoalCard({ title, icon, text = [], boldParagraphIndexes = [] }) {
  return (
    <div className="goal-card">
      <ReactVisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <img
            src={icon}
            alt=""
            className="goal-card__icon"
            style={getVisibleSensorAnimation(
              isVisible,
              "spin-coin 1s 0.5s backwards"
            )}
          />
        )}
      </ReactVisibilitySensor>
      <div className="goal-card__text-container">
        <h2 className="goal-card__title">{title}</h2>

        {text.map((textCard, index) => (
          <ReactVisibilitySensor partialVisibility key={index}>
            <p
              className={`goal-card__text${setAdditionalClasses(
                ["medium"],
                [boldParagraphIndexes.includes(index)]
              )}`}
              style={getVisibleSensorAnimation(
                isVisible,
                `fade-in-40px 1s ${index * 0.3}s ease-in-out backwards`
              )}
            >
              {textCard}
            </p>
          </ReactVisibilitySensor>
        ))}
      </div>
    </div>
  );
}

export default GoalCard;
